<template>
  <div>
    <author-view v-if="isAuthor && !isPeerReviewer && !isAdmin" :course-id="courseId" />
    <peer-reviewer-view v-if="isPeerReviewer && !isAdmin" :course-id="courseId" />
    <admin-view v-if="isAdmin" :course-id="courseId" :selected-tab="selectedTab" />
  </div>
</template>
<script>
  import ManageCourseBase from './ManageCourseBase.vue';
  import AuthorView from './WorkflowTab/AuthorView.vue';
  import PeerReviewerView from './WorkflowTab/PeerReviewerView.vue';
  import AdminView from './WorkflowTab/AdminView.vue';

  export default {
    components: {
      AuthorView,
      PeerReviewerView,
      AdminView,
    },
    extends: ManageCourseBase,
    props: {
        selectedTab: {
            type: String
        }
    },
  };
</script>